import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import {
  CreatePersonEventRequest,
  PersonEvent,
  PersonEventCategory,
  PersonEventEditorContext,
  UpdatePersonEventRequest,
  religiousEventTypeOptions,
} from '../models/person-event.model';

@Injectable({ providedIn: 'root' })
export class PersonEventService {
  constructor(private readonly http: HttpClient) {}

  getEvents(personId: string, kind?: string): Observable<PersonEvent[]> {
    let params = new HttpParams();
    if (kind) {
      params = params.set('kind', kind);
    }

    return this.http.get<PersonEvent[]>(`${environment.apiUrl}/people/${personId}/events`, { params }).pipe(
      map(events =>
        events.map(e =>
          e.category === 'ReligiousEvent' && e.religiousEventType && e.religiousEventType !== 'WeddingAnniversary'
            ? {
                ...e,
                eventTypeName:
                  religiousEventTypeOptions.find(o => o.value === e.religiousEventType)?.label ??
                  e.eventTypeName,
              }
            : e,
        ),
      ),
    );
  }

  getEditorContext(personId: string, kind: string): Observable<PersonEventEditorContext> {
    return this.http.get<PersonEventEditorContext>(`${environment.apiUrl}/people/${personId}/events/editor-context/${kind}`);
  }

  createEvent(personId: string, request: CreatePersonEventRequest): Observable<number> {
    return this.http.post<number>(`${environment.apiUrl}/people/${personId}/events`, request);
  }

  updateEvent(
    personId: string,
    category: PersonEventCategory,
    eventId: number,
    request: UpdatePersonEventRequest,
  ): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/people/${personId}/events/${category}/${eventId}`, request);
  }

  deleteEvent(personId: string, category: PersonEventCategory, eventId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/people/${personId}/events/${category}/${eventId}`);
  }
}
